import styled from "styled-components"

export const RegisterContainer = styled.div`
width: 80%;
margin: auto;
height: 95vh;
display: flex;
flex-direction: column;
align-items: flex-start;
justify-content: space-between;
max-width: 500px;
margin: auto;

h1{
    margin-bottom: 70px;
    margin-top: 55px;
}

label{
    margin-top: 15px;
}

input{
    margin: 0;
}

h5{
    text-align: start;
    font-size: small;
    font-weight: normal;
    margin: 30px 0;
}

a{
    color: #0202ed;
}

`